module.exports = __webpack_public_path__ + "static/media/facebook-community.1d9d975b.png";